// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__4HxSU","itemOpcoes":"Item_itemOpcoes__VjPSg"};